import(/* webpackMode: "eager" */ "C:\\DC\\projects\\2406mem\\app\\layout.jsx");
